
<template>
  <div class="lc_content">
				<div class="tit fw"><router-link to="/progess">{{$t("home.process.title")}}</router-link></div>
				<ul>
					<li>
						<img src="../assets/images/num1.gif" v-show="currentStep!=1">
						<img src="../assets/images/num1_red.gif" v-show="currentStep==1">
						<div>
							<p class="c_gray">{{$t("home.process.step_1.number")}}</p>
							<p><router-link to="/progess">{{$t("home.process.step_1.describe")}}</router-link></p>
						</div>
						<img class="right_jt" src="../assets/images/right01.gif">
					</li>
					<li>
						<img src="../assets/images/num2.gif" v-show="currentStep!=2">
						<img src="../assets/images/num2_red.gif" v-show="currentStep==2">
						<div>
							<p class="c_gray">{{$t("home.process.step_2.number")}}</p>
							<p><router-link to="/progess">{{$t("home.process.step_2.describe")}}</router-link></p>
						</div>
						<img class="right_jt" src="../assets/images/right01.gif">
					</li>
					<li>
						<img src="../assets/images/num3.gif" v-show="currentStep!=3">
						<img src="../assets/images/num3_red.gif" v-show="currentStep==3">
						<div>
							<p class="c_gray">{{$t("home.process.step_3.number")}}</p>
							<p><router-link to="/progess">{{$t("home.process.step_3.describe")}}</router-link></p>
						</div>
						<img class="right_jt" src="../assets/images/right01.gif">
					</li>
					<li>
						<img src="../assets/images/num4.gif" v-show="currentStep!=4">
						<img src="../assets/images/num4_red.gif" v-show="currentStep==4">
						<div>
							<p class="c_gray">{{$t("home.process.step_4.number")}}</p>
							<p><router-link to="/progess">{{$t("home.process.step_4.describe")}}</router-link></p>
						</div>
						<img class="right_jt" src="../assets/images/right01.gif">
					</li>
					<li>
						<img src="../assets/images/num5.gif" v-show="currentStep!=5">
						<img src="../assets/images/num5_red.gif" v-show="currentStep==5">
						<div>
							<p class="c_gray">{{$t("home.process.step_5.number")}}</p>
							<p><router-link to="/progess">{{$t("home.process.step_5.describe")}}</router-link></p>
						</div>
						<img class="right_jt" src="../assets/images/right01.gif">
					</li>
					<li>
						<img src="../assets/images/num6.gif" v-show="currentStep!=6">
						<img src="../assets/images/num6_red.gif" v-show="currentStep==6">
						<div>
							<p class="c_gray">{{$t("home.process.step_6.number")}}</p>
							<p><router-link to="/progess">{{$t("home.process.step_6.describe")}}</router-link></p>
						</div>
					</li>
				</ul>
			</div>
</template>

<script>
export default {
  name: 'JpPress',
  data() {
    return{
      currentStep: 1
    }
  },
  created() {
    let _this = this;
    setInterval(function() {
        _this.currentStep++;
        if (_this.currentStep > 6) _this.currentStep = 1
    }, 1500)
  }
}
</script>
